// Form1Layout мобильного приложения: справочники 36 → 37 → 38,
// фильтр parent_id и обязательность урочища по наличию дочерних записей.
const book = (handbooks, id) => handbooks.find(h => String(h.id) === String(id));
const normalize = value => String(value ?? '').trim().toLowerCase();
const idOf = value => typeof value === 'object' ? value?.id : value;

export const addressChildren = (handbooks, handbookId, parentId) =>
  parentId == null || parentId === '' ? [] : (book(handbooks, handbookId)?.references || [])
    .filter(r => String(r.parent_id) === String(parentId));

const resolve = (handbooks, handbookId, value, savedId, parent) => {
  if (!value || !parent) return null;
  const records = (book(handbooks, handbookId)?.references || [])
    .filter(r => r.parent_id == null || String(r.parent_id) === String(parent.id));
  const explicitId = typeof value === 'object' ? value.id : /^\d+$/.test(String(value)) ? value : savedId;
  const byId = records.find(r => String(r.id) === String(explicitId));
  if (byId && (typeof value === 'object' || /^\d+$/.test(String(value)) || normalize(value) === normalize(byId.name))) return byId;
  const matches = records.filter(r => normalize(r.name) === normalize(value?.name ?? value));
  // Старые карточки содержат названия. Не выбираем произвольную запись при дублях.
  return matches.length === 1 ? matches[0] : null;
};

export const resolveForestAddress = (form1, handbooks = []) => {
  const srfId = idOf(form1.srf);
  const srf = (book(handbooks, 12)?.references || []).find(r => String(r.id) === String(srfId)) ||
    (book(handbooks, 12)?.references || []).find(r => normalize(r.name) === normalize(form1.srf));
  const lvo = resolve(handbooks, 36, form1.lvo, form1.lvoId, srf);
  const ulvo = resolve(handbooks, 37, form1.ulvo, form1.ulvoId, lvo);
  const urc = resolve(handbooks, 38, form1.urc, form1.urcId, ulvo);
  return { srf, lvo, ulvo, urc, isUrcRequired: isTractRequired(ulvo, handbooks) };
};

export const isTractRequired = (district, handbooks = [], fallback = false) => {
  if (!district) return false;
  if (!book(handbooks, 38)) return fallback;
  return addressChildren(handbooks, 38, idOf(district)).length > 0;
};

export const addressOptions = records => records.map(r => ({
  value: String(r.id), label: r.name, description: r.description || null,
}));
